module.exports = __webpack_public_path__ + "static/media/bagarmossen.5d0fd7dd.jpg";